// FIXME: Update this configuration file based on your project information
export const BASE_URL = process.env.REACT_APP_API_URL;
export const GOOGLE_SITE_KEY = process.env.REACT_APP_GOOGLE_SITE_KEY;
